import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import Login from "../pages/authorization/Login.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";
import Studies from "../pages/studies/Studies.vue";
import Users from "../pages/users/Users.vue";
import Tasks from "../pages/tasks/Tasks.vue";
import Datapoints from "@/pages/Datapoints.vue";
import Dashboard from "@/pages/Dashboard.vue";
import Schemes from "@/pages/schemes/Schemes.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/datapoints",
    children: [
      {
        path: "/login",
        name: "Login",
        component: Login
      },
      // {
      //   path: "/dashboard",
      //   name: "dashboard",
      //   component: Dashboard,
      //   meta: {
      //     requiredAuth: true
      //   }
      // },
      {
        path: "/datapoints",
        name: "datapoints",
        component: Datapoints,
        meta: {
          requiredAuth: true
        }
      },
      {
        path: "/studies",
        name: "studies",
        component: Studies,
        meta: {
          requiredAuth: true
        }
      },
      {
        path: "/tasks",
        name: "tasks",
        component: Tasks,
        meta: {
          requiredAuth: true
        }
      },
      {
        path: "/schemes",
        name: "schemes",
        component: Schemes,
        meta: {
          requiredAuth: true
        }
      },
      {
        path: "/users",
        name: "users",
        component: Users,
        meta: {
          requiredAuth: true
        }
      }
    ]
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
